import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PaymentStore } from '../service/payment.store';
import { Observable } from 'rxjs/Observable';
import { Payment } from '../models/payment';

@Injectable()
export class InitialPaymentResolver implements Resolve<any> {

  constructor(
    private translateService: TranslateService,
    private paymentStore: PaymentStore
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Payment[]> {
    const id = route.params[ 'id' ];
    const eventPartyId = route.params[ 'eventPartyId' ];

    if (!id) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.GET_LATEST_PAYMENT'));
    }

    if (eventPartyId) {
      return this.paymentStore.loadLatestInitialPaymentByParty(id, eventPartyId);
    } else {
      return this.paymentStore.loadLatestInitialPayments(id);
    }

  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/initial-payment.resolver.ts